module.exports = __webpack_public_path__ + "assets/img/about_banner.ead2361a.png";